import { useQuery } from 'hooks/useCustomQuery';
import { getAllPartnerServiceProfiles } from 'API/ServiceProfiles/getAllServiceProfiles';

const useGetAllPartnerServiceProfiles = ({ wholesalerID, enabled = true }) => {
    return useQuery({
        queryKey: ['serviceProfiles', 'partner', 'all'],
        queryFn: () => getAllPartnerServiceProfiles({ wholesalerID }),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: enabled && !!wholesalerID,
        select: (res) => res.data,
    });
};

export default useGetAllPartnerServiceProfiles;
